import O from "./O";
import { DragGeometryContext } from './MouseDragProvider';
import { useContext } from 'react';
import { 
  CellResizeContext ,
  ColumnResizeContext,
} from './Contexts';

export default function DebuggerPanel(){

  const dragGeometry = useContext(DragGeometryContext);
  const cellResizeContext = useContext(CellResizeContext);
  const crc = useContext(ColumnResizeContext);

  const order = [
    {...dragGeometry,info:undefined},
    cellResizeContext,
    crc
  ]

  return null && (
    <div style={{
      position:'fixed',
      top:0,
      right:0,
      width:300,
      overflow:'visible',

    }}>
      {order.map(obj => (
        <div style={{
          background:'black',
        }}>
          <O>{obj}</O>
        </div>
      ))}
    </div>
  )
}
